import React from "react";

export const Spinner = ({ size = 24 }) => (
  <div
    style={{ width: size, height: size, borderWidth: 2 }}
    className="border-[#F4844B] border-t-transparent rounded-full animate-spin"
  />
);

export const FullScreenLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <Spinner size={36} />
  </div>
);

export const PageHeader = ({ title, subtitle, right, back }) => (
  <div className="px-5 pt-6 pb-4 flex items-start justify-between gap-3">
    <div className="flex items-start gap-3 flex-1 min-w-0">
      {back}
      <div className="min-w-0">
        <h1 className="font-instrument text-2xl font-semibold text-[#0A4C36] leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-[#78716C] mt-0.5 truncate">{subtitle}</p>}
      </div>
    </div>
    {right}
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle, action }) => (
  <div className="text-center py-12 px-6">
    {Icon && (
      <div className="w-16 h-16 rounded-3xl bg-[#FCD9C8] mx-auto mb-4 flex items-center justify-center">
        <Icon size={28} className="text-[#F4844B]" />
      </div>
    )}
    <h3 className="font-instrument text-lg font-medium text-[#1C1917]">{title}</h3>
    {subtitle && <p className="text-sm text-[#78716C] mt-1">{subtitle}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
